import React, { useEffect } from 'react';
import AOS from 'aos';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'aos/dist/aos.css';
import '../assets/css/reset.css';
import '../assets/css/fonts.css';
import '../assets/css/style.css';
import { useNavigate } from 'react-router-dom';

function Home() {
  const navigate = useNavigate();

  // ✅ 로컬스토리지 관리 유틸
  const handleStorage = {
    setStorage: (name, value) => {
      const today = new Date();
      const expire = today.setDate(today.getDate() + 1); // 1일 후 만료
      const item = { value, expire };
      localStorage.setItem(name, JSON.stringify(item));
    },
    getStorage: (name) => {
      const itemStr = localStorage.getItem(name);
      if (!itemStr) return null;
      const item = JSON.parse(itemStr);
      const now = new Date();
      if (now.getTime() > item.expire) {
        localStorage.removeItem(name);
        return null;
      }
      return item.value;
    },
  };

  useEffect(() => {
    AOS.init();

    // ✅ 스크롤 시 top 버튼 표시
    const handleScroll = () => {
      const topButton = document.querySelector('.top_btn');
      if (window.scrollY > 300) {
        topButton.style.display = 'block';
      } else {
        topButton.style.display = 'none';
      }
    };
    window.addEventListener('scroll', handleScroll);

    // ✅ 팝업 제어
    const toggleMainPopup = () => {
      const popup = document.getElementById('popupWrapper');
      if (!popup) return;

      if (handleStorage.getStorage('popupToday')) {
        popup.style.display = 'none';
      } else {
        popup.style.display = 'flex';
      }

      // 오늘 하루 보지 않기 버튼
      document.querySelector('.btn_today_close')?.addEventListener('click', function () {
        handleStorage.setStorage('popupToday', 1);
        popup.style.display = 'none';
      });

      // 닫기 버튼 (X 포함)
      document.querySelectorAll('.btn_close').forEach(function (btn) {
        btn.addEventListener('click', function () {
          popup.style.display = 'none';
        });
      });
    };

    toggleMainPopup();

    // ✅ 클린업
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const screenTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <nav className="navbar fixed-top shadow-sm navbar-expand bg-white px-5">
        <div className="container-fluid">
          <a className="nav-logo" href="/">
            <img src="/images/nav.png" alt="꼬르륵 로고" />
          </a>
          <div className="d-flex gap-2">
            <a className="nav-btn btn d-flex align-items-center" href="https://kkoruruk.com/ceo/">
              꼬르륵 사장님
            </a>
          </div>
        </div>
      </nav>

      <div className="container-fluid main">
        <div className="main-in">
          <span className="line"></span>
          <div className="main-logo-wrap">
            <div className="main-logo">
              <img src="/images/main_2.svg" alt="꼬르륵 로고" />
            </div>
          </div>
          <div className="container main-text-box">
            <h1 className="main-text">우리동네</h1>
            <h1 className="main-text">배달어플</h1>
          </div>
        </div>
      </div>

      <div className="container-fluid py-5">
        <div className="container py-5">
          <h2 className="con-big-title pb-5">
            다같이 먹는 배달어플 <br />
            <b>함께 할수록</b> 배달이 더 맛있어진다!
          </h2>
          <div className="con-area pt-5">
            <div data-aos="fade-up" className="con01 pb-2">
              <img src="/images/con01.png" alt="꼬르륵 어플" />
              <h5 className="con-title pt-2">배고픈 순간을 더 행복하게!</h5>
              <p className="con-text">
                맛있는 기다림을 친구들과 더 행복하게, <br />그 생각으로 '꼬르륵'이 탄생했어요.
              </p>
            </div>
            <div data-aos="fade-up" className="con02 pb-2">
              <img src="/images/con02.png" alt="배달 음식" />
              <h5 className="con-title pt-2">함께라서 더 맛있는 순간!</h5>
              <p className="con-text">
                혼밥 대신 친구와 함께 리워드를 나누는 즐거움을 위해
                <br />
                '꼬르륵' 앱을 만들었어요!
              </p>
            </div>
            <div data-aos="fade-up" className="con03 pb-2">
              <img src="/images/con03.png" alt="배달 기사" />
              <h5 className="con-title pt-2">맛있는 순간을 더 빠르게, 더 따뜻하게!</h5>
              <p className="con-text">'꼬르륵' 자체 배달 시스템으로 배고픈 순간 기다리지 마세요.</p>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid bob py-5" data-aos="fade-right">
        <div className="container py-5">
          <h2 className="bob-big-title pb-5">" 🍚 밥친구, 이런기능이에요!</h2>
          <div className="bob-inner">
            <div className="content-img pt-5">
              <img data-aos="fade-right" className="bimg01" src="/images/rice_03.png" alt="" />
              <img data-aos="fade-up" className="bimg02 " src="/images/rice_02.png" alt="" />
              <img data-aos="fade-left" className="bimg01" src="/images/rice_04.png" alt="" />
            </div>
            <div className="content-text px-4 py-5">
              <ul>
                <li>
                  <h6 className="bob-title">1.친구 초대하면 캐시 듬뿍!</h6>
                  <p className="bob-text">
                    친구를 초대하면 리워드 포인트가 쌓이고, <br />
                    친구가 주문할 때마다 추가 리워드가 적립돼요!
                  </p>
                </li>
                <li>
                  <h6 className="bob-title">2.초대할수록 더 맛있게!</h6>
                  <p className="bob-text">
                    초대 링크를 공유하고, 친구와 함께 배달의 기쁨을 누리세요!
                    <br />
                    리워드는 두 배, 기쁨은 세 배!
                  </p>
                </li>
                <li>
                  <h6 className="bob-title">3.함께하면 더 든든한 한 끼!</h6>
                  <p className="bob-text">
                    친구를 초대해 포인트를 모으고, 다음 주문은 공짜로 즐겨보세요!
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid down py-5">
        <div className="container down-in">
          <div data-aos="zoom-in">
            <h1 className="down-title">
              우리 밥친구 하자! <br />
              오늘도 꼬르륵~ 배달 파티를 시작해요!
            </h1>
            <h1 className="down-title-m">
              우리 밥친구 하자! <br />
              오늘도 꼬르륵~
              <br />
              배달 파티를 시작해요!
            </h1>
            <div className="appdown_box">
              <a
                className="down-btn s1"
                href="https://play.google.com/store/apps/details?id=com.gysoft.grr_user_app&hl=ko"
                target="_blank"
                rel="noreferrer"
              >
                <img src="/images/google_btn.png" alt="꼬르륵 구글 스토어" />
              </a>
              <a
                className="down-btn s2"
                href="https://apps.apple.com/kr/app/%EA%BC%AC%EB%A5%B4%EB%A5%B5/id6744098527"
                target="_blank"
                rel="noreferrer"
              >
                <img src="/images/appStore_btn.png" alt="꼬르륵 앱 스토어" />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid footer p-3">
        <div className="container">
          <div className="footer-logo">
            <img src="/images/footer.png" alt="꼬르륵 로고" />
          </div>
          <div className="footer-txt pt-4">
            <p className="f-txt">주식회사 꼬르륵 | 1833-4756</p>
            <p className="f-txt p">
              <p>
                대표이사 <b className="f-b">안현숙</b>&nbsp; l &nbsp;
              </p>
              <p>
                사업자등록번호 <b className="f-b">863-88-03560</b>&nbsp; l &nbsp;
              </p>
              <p>
                통신판매업 <b className="f-b">제2026-충남천안-0530 호</b>
              </p>
            </p>
            <p className="f-txt">충청남도 천안시 서북구 쌍용대로 133, 502호(쌍용동)</p>
          </div>
        </div>
      </div>

      <div className="top_btn">
        <button onClick={screenTop} className="top_bt">
          ▲
        </button>
      </div>

      {/* ✅ 팝업 영역 */}
      {/* <div id="popupWrapper" className="popup-wrapper" style={{ display: 'none' }}>
        <div className="popup">
          <div className="popup_close">
            <button className="btn_close close-btn pop-btn01">✕</button>
          </div>
          <a href="https://kkoruruk.com/ceo/">
            <img src="/images/popup.png" alt="사장님 모집 팝업" />
          </a>
          <div className="buttons">
            <button className="btn_today_close">오늘 하루 보지 않기</button>
          </div>
        </div>
      </div> */}
    </>
  );
}

export default Home;
